import { ColDef } from 'ag-grid-community';

export const QUARTERLY_FEEDBACK_COLUMNS: ColDef[] = [
  { headerName: 'Employee ID',        field: 'employeeId',            minWidth: 130, sortable: true, filter: false, headerTooltip: 'Employee ID',        tooltipField: 'employeeId' },
  { headerName: 'Employee Name',      field: 'employeeName',          minWidth: 170, sortable: true, filter: false, headerTooltip: 'Employee Name',      tooltipField: 'employeeName' },
  { headerName: 'Reporting Manager',  field: 'reportingManagerName',  minWidth: 170, sortable: true, filter: false, headerTooltip: 'Reporting Manager',  tooltipField: 'reportingManagerName' },
  { headerName: 'Last Hire Date',     field: 'lastHireDate',          minWidth: 130, sortable: true, filter: false, headerTooltip: 'Last Hire Date',     tooltipField: 'lastHireDate' },
  { headerName: 'Vendor',             field: 'employerName',          minWidth: 170, sortable: true, filter: false, headerTooltip: 'Vendor',             tooltipField: 'employerName' },
  { headerName: 'L3 Manager',         field: 'l3Name',                minWidth: 170, sortable: true, filter: false, headerTooltip: 'L3 Manager',         tooltipField: 'l3Name' },
  { headerName: 'Performance Rating', field: 'performanceRating',     minWidth: 160, sortable: true, filter: false, headerTooltip: 'Performance Rating (new bucketed rating; blank on legacy rows)', tooltipField: 'performanceRating' },
  { headerName: 'Technical Rating',   field: 'technicalRating',       minWidth: 150, sortable: true, filter: false, headerTooltip: 'Technical Rating (legacy 1-5; blank on new-form rows)',   tooltipField: 'technicalRating' },
  { headerName: 'Behavioural Rating', field: 'behaviouralRating',     minWidth: 160, sortable: true, filter: false, headerTooltip: 'Behavioural Rating (legacy 1-5; blank on new-form rows)', tooltipField: 'behaviouralRating' },
  {
    headerName: 'Comments',
    field: 'comments',
    minWidth: 220,
    flex: 1,
    sortable: false,
    filter: false,
    wrapText: true,
    autoHeight: true,
    headerTooltip: 'Comments',
    tooltipField: 'comments',
    cellStyle: { 'white-space': 'pre-line', 'line-height': '1.8', 'padding': '10px 16px' },
  },
];

export const QUARTERLY_FEEDBACK_TABLE_CONFIG = {
  enableRowSelection: false,
  enableActions: false,
  enablePagination: true,
  paginationPageSize: 20,
  enableSorting: true,
  enableFiltering: false,
  enableColumnResize: true,
};